export const EMPTY_DESCRIPTION_DISPLAY_TEXT = 'No description available';

export function normalizeDescriptionFromBackend(desc) {
  const value = desc ?? '';
  if (!value.trim()) return '';
  if (value.trim() === EMPTY_DESCRIPTION_DISPLAY_TEXT) return '';
  return value;
}

export function getDescriptionDisplayText(description) {
  const normalized = normalizeDescriptionFromBackend(description);
  return normalized || EMPTY_DESCRIPTION_DISPLAY_TEXT;
}

export function normalizeDescriptionForBackend(description) {
  const value = (description ?? '').trim();
  if (!value || value === EMPTY_DESCRIPTION_DISPLAY_TEXT) return '';
  return value;
}
